import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import CrudForm from '../../crud/CrudForm'
import {
    usercompaniesService as service,
    companyService,
    usercompaniesService,
} from '../../../services'
import { useTranslation } from 'react-i18next'
import CrudFormTabs from '../../crud/CrudFormTabs'
import TabTimetableUser from './TabTimetableUser'
import { Box, Button, Grid, Modal } from '@mui/material'
import TabDisabledaysUser from './TabDisabledaysUser'
import { idCompany } from '../../../utils/session'
import { Link } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import { resolveBlock } from '../../common/blockAction'
import { useBlockToast } from '../../common/BlockFeedback'
import TabShare from './TabShare'
import TabRental from './TabRental'

const initElement = {
    nifUser: null,
    acceptByCompany: null,
    dateAcceptByCompany: null,
    acceptByUser: null,
    dateAcceptByUser: null,
    dateEnd: null,
    user: { id: null, name: '' },
    company: { id: null, name: '' },
}

export default function FormUsers(props) {
    const style = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1000,
        maxWidth: '80%',
        bgcolor: 'white',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    }

    const [objectform, setObjectform] = React.useState({ ...initElement })
    type FormParms = {
        id: string
        company: string
    }
    let { id, company } = useParams<FormParms>()
    const [idRow, setIdrow] = useState(id ? Number(id) : 0)
    const [iduser, setIduser] = useState<any>(null)
    const { t, i18n } = useTranslation()
    const { showBlock } = useBlockToast()
    const [object, setObject] = useState({
        ...initElement,
        ['company']: { id: company, name: '' },
    })

    var stateForm = {
        openConfirm: false,
        openRecovery: false,
        openAccept: false,
        openReject: false,
        iduser: null,
    }

    const estructureform = [
        {
            type: 'input',
            name: 'nifUser',
            col: 4,
        },
        {
            type: 'autocomplete',
            name: 'user.id',
            service: usercompaniesService.combouser,
            col: 4,
            readonly: true,
        },
        {
            type: 'input',
            name: 'maxMoneyMonthShare',
            col: 4,
            inputtype: 'number',
        },
        {
            type: 'checkbox',
            name: 'acceptByCompany',
            col: 4,
            readonly: true,
        },
        {
            type: 'input',
            name: 'dateAcceptByCompany',
            inputtype: 'date',
            col: 4,
            readonly: true,
        },
        {
            type: 'checkbox',
            name: 'acceptByUser',
            col: 4,
            readonly: true,
        },
        {
            type: 'input',
            name: 'dateAcceptByUser',
            inputtype: 'date',
            col: 4,
            readonly: true,
        },
        {
            type: 'input',
            name: 'dateEnd',
            inputtype: 'date',
            col: 4,
        },
    ]

    const recoveryElement = function (objectedit, element) {
        //objectedit = element
        objectedit['nifUser'] = element['nifUser']
        objectedit['acceptByCompany'] = element['acceptByCompany']
        objectedit['dateAcceptByCompany'] = element['dateAcceptByCompany']
        objectedit['acceptByUser'] = element['acceptByUser']
        objectedit['dateAcceptByUser'] = element['dateAcceptByUser']
        objectedit['dateEnd'] = element['dateEnd']
        objectedit['user'] =
            element['user'] != null ? element['user'] : { id: null, name: '' }
        objectedit['company'] = element['company']

        return objectedit
    }

    const isValid = function (object) {
        return null
    }

    const tabTabTimetable = (id, objectform) => {
        if (
            objectform != null &&
            objectform['user'] != null &&
            objectform['user']['id'] != null
        ) {
            return (
                <TabTimetableUser
                    idcompany={idCompany()}
                    iduser={objectform['user']['id']}
                    userc={id}
                />
            )
        } else {
            return (
                <Grid container>
                    <Grid xs={12}>
                        <p>El usuario aun no se ha dado de alta en Mobify</p>
                    </Grid>
                </Grid>
            )
        }
    }

    const tabTabDisabledays = (id, objectform) => {
        if (
            objectform != null &&
            objectform['user'] != null &&
            objectform['user']['id'] != null
        ) {
            return (
                <TabDisabledaysUser
                    idcompany={idCompany()}
                    iduser={objectform['user']['id']}
                    userc={id}
                />
            )
        } else {
            return (
                <Grid container>
                    <Grid xs={12}>
                        <p>El usuario aun no se ha dado de alta en Mobify</p>
                    </Grid>
                </Grid>
            )
        }
    }

    const tabRent = (id, objectform) => {
        if (
            objectform != null &&
            objectform['user'] != null &&
            objectform['user']['id'] != null
        ) {
            return (
                <TabRental
                    idcompany={idCompany()}
                    idclient={objectform['user']['id']}
                />
            )
        } else {
            return (
                <Grid container>
                    <Grid xs={12}>
                        <p>El usuario aun no se ha dado de alta en Mobify</p>
                    </Grid>
                </Grid>
            )
        }
    }
    const tabShare = (id, objectform) => {
        if (
            objectform != null &&
            objectform['user'] != null &&
            objectform['user']['id'] != null
        ) {
            return (
                <TabShare
                    idcompany={idCompany()}
                    idclient={objectform['user']['id']}
                />
            )
        } else {
            return (
                <Grid container>
                    <Grid xs={12}>
                        <p>El usuario aun no se ha dado de alta en Mobify</p>
                    </Grid>
                </Grid>
            )
        }
    }

    const initobject = (saveState, object) => {
        var haveUser =
            object['user'] != null &&
            object['user']['id'] != null &&
            object['user']['id'] > 0

        if (haveUser) {
            setStateInParent('iduser', object['user']['id'], saveState)
        }
    }

    const moreActions = (getObject, state, saveState) => {
        var object = getObject()

        var haveUser =
            object['user'] != null &&
            object['user']['id'] != null &&
            object['user']['id'] > 0

        return (
            <>
                {haveUser && object['dateEnd'] == null && (
                    <Button
                        variant="outlined"
                        color="secondary"
                        style={{ marginLeft: '30px' }}
                        onClick={() => {
                            setStateInParent('openConfirm', true, saveState)
                        }}
                    >
                        {' '}
                        Dar de baja
                    </Button>
                )}

                {haveUser && object['dateEnd'] != null && (
                    <Button
                        variant="outlined"
                        color="secondary"
                        style={{ marginLeft: '30px' }}
                        onClick={() => {
                            setStateInParent('openRecovery', true, saveState)
                        }}
                    >
                        {' '}
                        Recuperar usuario
                    </Button>
                )}

                {(object['acceptByCompany'] == null ||
                    !object['acceptByCompany']) &&
                    haveUser && (
                        <Button
                            variant="outlined"
                            color="primary"
                            style={{ marginLeft: '30px' }}
                            onClick={() => {
                                setStateInParent('openAccept', true, saveState)
                            }}
                        >
                            {' '}
                            Aceptar usuario
                        </Button>
                    )}
                {(object['acceptByCompany'] == null ||
                    object['acceptByCompany']) &&
                    haveUser && (
                        <Button
                            variant="outlined"
                            color="primary"
                            style={{ marginLeft: '30px' }}
                            onClick={() => {
                                setStateInParent('openReject', true, saveState)
                            }}
                        >
                            {' '}
                            Rechazar usuario
                        </Button>
                    )}
            </>
        )
    }

    const setStateInParent = (name, val, call) => {
        if (val) {
            call(name, val)
        } else {
            call(name, val)
        }
    }

    const sendDateEndRecovery = (user) => {
        service.recoveryuser(user, (data, error) => {
            if (data && data.data) {
                window.location.reload()
            } else {
                // MOBD-66: era toast.success (verde) sobre un fallo. Si el backend manda un bloqueo se
                // pinta con su motivo/solucion/CTA; si no, al menos se muestra como error.
                const blockInfo = resolveBlock(error)
                if (blockInfo) {
                    showBlock(blockInfo)
                } else {
                    toast.error(error?.mes, {
                        position: toast.POSITION.TOP_CENTER,
                    })
                }
            }
        })
    }

    const sendDateEnd = (user) => {
        service.finalice(user, (data, error) => {
            if (data && data.data) {
                window.location.reload()
            } else {
                toast.error(error.mes, {
                    position: toast.POSITION.TOP_CENTER,
                })
            }
        })
    }

    const sendAccept = (user) => {
        service.accept(user, (data, error) => {
            if (data && data.data) {
                window.location.reload()
            } else {
                // MOBD-66: era toast.success (verde) sobre un fallo. Si el backend manda un bloqueo se
                // pinta con su motivo/solucion/CTA; si no, al menos se muestra como error.
                const blockInfo = resolveBlock(error)
                if (blockInfo) {
                    showBlock(blockInfo)
                } else {
                    toast.error(error?.mes, {
                        position: toast.POSITION.TOP_CENTER,
                    })
                }
            }
        })
    }

    const sendReject = (user) => {
        service.reject(user, (data, error) => {
            if (data && data.data) {
                window.location.reload()
            } else {
                // MOBD-66: era toast.success (verde) sobre un fallo. Si el backend manda un bloqueo se
                // pinta con su motivo/solucion/CTA; si no, al menos se muestra como error.
                const blockInfo = resolveBlock(error)
                if (blockInfo) {
                    showBlock(blockInfo)
                } else {
                    toast.error(error?.mes, {
                        position: toast.POSITION.TOP_CENTER,
                    })
                }
            }
        })
    }

    return (
        <>
            <CrudFormTabs
                objectform={{
                    ...object,
                }}
                estructureform={estructureform}
                i18n={'usertocompany'}
                urledit={'/users/edit/'}
                urlCancel={'/users/'}
                service={service}
                recoveryElement={recoveryElement}
                valid={isValid}
                haveMoreActions={true}
                moreActions={moreActions}
                stateform={stateForm}
                initobject={initobject}
                tabs={[
                    {
                        title: 'company.tabs.timetable',
                        method: tabTabTimetable,
                    },
                    {
                        title: 'users.tab.share',
                        method: tabShare,
                    },
                    {
                        title: 'users.tab.rent',
                        method: tabRent,
                    },
                ]}
                haveInside={(state, saveState) => {
                    return (
                        <>
                            <Modal
                                open={state.openRecovery}
                                onClose={() =>
                                    setStateInParent(
                                        'openRecovery',
                                        false,
                                        saveState
                                    )
                                }
                                aria-labelledby="simple-modal-title"
                                aria-describedby="simple-modal-description"
                            >
                                <Box sx={style}>
                                    <div style={{ marginBottom: '30px' }}>
                                        ¿Deseas volver a dar acces a este
                                        usuario?
                                    </div>
                                    <div>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            style={{ marginRight: '30px' }}
                                            onClick={() =>
                                                setStateInParent(
                                                    'openRecovery',
                                                    false,
                                                    saveState
                                                )
                                            }
                                        >
                                            {' '}
                                            Cancelar
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                sendDateEndRecovery(
                                                    state.iduser
                                                )
                                            }}
                                        >
                                            {' '}
                                            Recuperar usuario{' '}
                                        </Button>
                                    </div>
                                </Box>
                            </Modal>
                            <Modal
                                open={state.openConfirm}
                                onClose={() =>
                                    setStateInParent(
                                        'openConfirm',
                                        false,
                                        saveState
                                    )
                                }
                                aria-labelledby="simple-modal-title"
                                aria-describedby="simple-modal-description"
                            >
                                <Box sx={style}>
                                    <div style={{ marginBottom: '30px' }}>
                                        ¿Quieres dar de baja a este usuario?
                                    </div>
                                    <div>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            style={{ marginRight: '30px' }}
                                            onClick={() =>
                                                setStateInParent(
                                                    'openConfirm',
                                                    false,
                                                    saveState
                                                )
                                            }
                                        >
                                            {' '}
                                            Cancelar
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                sendDateEnd(state.iduser)
                                            }}
                                        >
                                            {' '}
                                            Dar de baja{' '}
                                        </Button>
                                    </div>
                                </Box>
                            </Modal>
                            <Modal
                                open={state.openAccept}
                                onClose={() =>
                                    setStateInParent(
                                        'openAccept',
                                        false,
                                        saveState
                                    )
                                }
                                aria-labelledby="simple-modal-title"
                                aria-describedby="simple-modal-description"
                            >
                                <Box sx={style}>
                                    <div style={{ marginBottom: '30px' }}>
                                        ¿Quieres aceptar este usuario?
                                    </div>
                                    <div>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            style={{ marginRight: '30px' }}
                                            onClick={() =>
                                                setStateInParent(
                                                    'openAccept',
                                                    false,
                                                    saveState
                                                )
                                            }
                                        >
                                            {' '}
                                            Cancelar
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                sendAccept(state.iduser)
                                            }}
                                        >
                                            {' '}
                                            Aceptar usuario{' '}
                                        </Button>
                                    </div>
                                </Box>
                            </Modal>
                            <Modal
                                open={state.openReject}
                                onClose={() =>
                                    setStateInParent(
                                        'openReject',
                                        false,
                                        saveState
                                    )
                                }
                                aria-labelledby="simple-modal-title"
                                aria-describedby="simple-modal-description"
                            >
                                <Box sx={style}>
                                    <div style={{ marginBottom: '30px' }}>
                                        ¿Quieres rechazar este usuario?
                                    </div>
                                    <div>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            style={{ marginRight: '30px' }}
                                            onClick={() =>
                                                setStateInParent(
                                                    'openReject',
                                                    false,
                                                    saveState
                                                )
                                            }
                                        >
                                            {' '}
                                            Cancelar
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                sendReject(state.iduser)
                                            }}
                                        >
                                            {' '}
                                            Rechazar usuario{' '}
                                        </Button>
                                    </div>
                                </Box>
                            </Modal>
                        </>
                    )
                }}
            />
        </>
    )
}
